<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  isFree: {
    type: Boolean,
    default: false,
  },
  reason: {
    type: String,
    default: '',
  },
  messageCount: {
    type: Number,
    default: 0,
  },
  messageLimit: {
    type: Number,
    default: 0,
  },
  remainingMessages: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();
const router = useRouter();

const bannerMessage = computed(() => {
  if (props.reason === 'message_limit_exceeded') {
    return t('PLAN_LIMIT.MESSAGE_LIMIT_EXCEEDED', {
      count: props.messageCount,
      limit: props.messageLimit,
    });
  }
  if (props.reason === 'subscription_expired') {
    return t('PLAN_LIMIT.SUBSCRIPTION_EXPIRED');
  }
  return t('PLAN_LIMIT.BLOCKED');
});

const goToSubscriptions = () => {
  router.push({ name: 'subscription_settings' });
};
</script>

<template>
  <div
    class="flex items-center justify-between px-4 py-3 mb-2 bg-yellow-50 border border-yellow-200 rounded-lg"
  >
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 mt-0.5">
        <svg
          class="w-5 h-5 text-yellow-600"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <div class="flex-1">
        <p class="text-sm font-medium text-yellow-800">
          {{ bannerMessage }}
        </p>
        <p
          v-if="isFree && remainingMessages > 0"
          class="mt-1 text-xs text-yellow-700"
        >
          {{
            t('CONVERSATION.PLAN_LIMIT.REMAINING_MESSAGES', {
              count: remainingMessages,
            })
          }}
        </p>
      </div>
    </div>
    <button
      class="flex-shrink-0 px-4 py-2 text-sm font-medium text-yellow-900 bg-yellow-100 border border-yellow-300 rounded-md hover:bg-yellow-200 transition-colors"
      @click="goToSubscriptions"
    >
      {{ t('PLAN_LIMIT.UPGRADE_PLAN') }}
    </button>
  </div>
</template>
